import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, Container, ContainerFlex, TextLocalized } from '../components/styled/Styled';

import { HttpConnection, HttpMethod, HttpOperations } from '../components/util/HttpConnection';
import { getTextLang, LanguageContext } from '../components/providers/LanguageProvider';
import GoodPracticeTypeItem from '../components/GoodPracticeTypeItem';

const ImprovementBlockDetail = () => {
    const [item, setItem] = useState();
    const { language } = useContext(LanguageContext);
    const location = useLocation();
    const history = useNavigate();

    useEffect(() => {
        HttpConnection(`${HttpOperations.block}/${location.state.item.id_block}`,
            response => {
                setItem(response.item);
            }, error => {
                console.log(error);
            }, HttpMethod.get);
    }, [location.state.item.id_block])

    return (
        item != null ?
            <ContainerFlex width="12" justify="center" px="32" >
                <Container width="12" lg="8">
                    <Card width="12" shadowOn flex mv="16" px="16" align="center" color="color-green-dark" fontColor="color-white">
                        <Container width="12" fontSize="18px" fontWeight="300" radiusbl="0px" radiusbr="0px" children={<TextLocalized children="msgImprovement" />} />
                        <Container mt="8" fontSize="12px" children={<TextLocalized children="msgImprovementSubtitle" />} />
                    </Card>
                    <ContainerFlex width="12" mv="32" pl="8" fontWeight="bold">
                        <Button onClick={() => history(-1)} children={<TextLocalized children="msgDrawer3" />} />
                        <Container mh="16" children=">" />
                        {item ? <Container children={`${getTextLang(item, 'name', language)}`} /> : null}
                    </ContainerFlex>
                    <ContainerFlex width="12" align="stretch">
                        {item.groups.map((group) => <GoodPracticeTypeItem key={group.id_group} item={group} showIndicator />)}
                    </ContainerFlex>
                </Container>
            </ContainerFlex>
            : null
    );
};

export default ImprovementBlockDetail;